import { useQuery } from 'react-query';
import { DeductionsComponentType, EarningsComponentType } from 'components/SalaryComponents/types';
import api from 'api';
import { PayrollListSalaryComponentsQueryVariables } from 'api/gql-utils/salaryComponents/types';
import { queryKeys } from '../data';
import { filterSalaryComponents } from '../../../utils';

export const useArrearsComponetsList = () => {
  const earningsComponentsFilter: PayrollListSalaryComponentsQueryVariables = {
    category: 'EARNINGS_CATEGORY',
    status: 'COMPONENT_STATUS_ACTIVE',
  };

  //TODO: uncomment this once deduction components are supported in Arrears
  // const recurringDeductionsFilter: PayrollListSalaryComponentsQueryVariables = {
  //   category: 'DEDUCTIONS_CATEGORY',
  //   status: 'COMPONENT_STATUS_ACTIVE',
  //   payType: 'LIST_RECURRING_TYPE',
  // };

  // const {
  //   isLoading: isLoadingDeductions,
  //   data: deductionComponents = [],
  //   error: errorDeductions,
  //   refetch: refetchDeductions,
  // } = useQuery({
  //   queryKey: [queryKeys.ARREARS_COMPONENTS_LIST, recurringDeductionsFilter],
  //   queryFn: () =>
  //     api.salaryComponents.queries.listSalaryComponents<DeductionsComponentType>(
  //       recurringDeductionsFilter,
  //     ),
  //   select: (data) => {
  //     return (data?.payrollListSalaryComponents?.data?.salaryComponents || []).filter(
  //       (component) => !!component?.settings?.behaviour?.arrearBehaviour?.considerInArrear,
  //     );
  //   },
  // });

  const {
    isLoading: isLoadingEarnings,
    data: earningsComponents = [],
    error: errorEarnings,
    refetch: refetchEarnings,
  } = useQuery({
    queryKey: [queryKeys.ARREARS_COMPONENTS_LIST, earningsComponentsFilter],
    queryFn: () =>
      api.salaryComponents.queries.listSalaryComponents<EarningsComponentType>(
        earningsComponentsFilter,
      ),
    select: (data) => {
      return (data?.payrollListSalaryComponents?.data?.salaryComponents || []).filter(
        (component) => !!component?.settings?.behaviour?.arrearBehaviour?.considerInArrear,
      );
    },
  });

  //TODO: uncomment this once deduction components are supported in Arrears
  // const components = [...earningsComponents, ...deductionComponents];
  const components = [...earningsComponents]

  const getSalaryComponentById = (id: string) => {
    return components.find((item) => item.id === id);
  };

  const searchSalaryComponents = (skipComponentIds: string[]) => {
    return filterSalaryComponents<EarningsComponentType | DeductionsComponentType>(
      components,
      '',
      skipComponentIds,
    );
  };

  return {
    searchSalaryComponents,
    getSalaryComponentById,
    //TODO: uncomment this once deduction components are supported in Arrears
    // isFetchingSalaryComponents: isLoadingDeductions || isLoadingEarnings,
    // error: errorDeductions || errorEarnings,
    // refetch: () => {
    //   refetchEarnings();
    //   refetchDeductions();
    // },
    isFetchingSalaryComponents: isLoadingEarnings,
    error: errorEarnings,
    refetch: refetchEarnings
  };
};
